



import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class AgeMilestones extends Vue {
  @Prop(Number) type!: number

  get imageClass(): string {
    return `age${this.type}`
  }
}
